Namespace 'CustomerVisualMode.Filters.LastInterval.Converters'

class CustomerVisualMode.Filters.LastInterval.Converters.HourConverter
  constructor: ->
    @anHourInSeconds = moment.duration(1, 'hours').asSeconds()

  toSeconds: (hour) ->
    {
      name: @_label(hour)
      interval: @_hoursInSeconds(hour)
    }

  canConvert: (seconds) ->
    (seconds % @anHourInSeconds) == 0

  getLabelFromSeconds: (seconds) ->
    @_label(moment.duration(seconds, 'seconds').asHours())

  _hoursInSeconds: (hour) ->
    moment.duration(hour, 'hours').asSeconds()

  _label: (hour) ->
    I18n.t('customer_visual_mode.filters.date.last_interval.hour', count: hour)
